import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import PassiveAuraType from "@/roc/effects/PassiveAura/PassiveAuraType";
import EffectAmount from "@/roc/effects/EffectAmount";

const PalaceOfFineArts = {
  id: "161",
  name: "Palace of Fine Arts",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Palace_of_Fine_Arts",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Palace_of_Fine_Arts',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel((level) => {
        return Math.min(11, Math.max(1, Math.floor(level / 6) + 1));
      }).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          133,140,147,154,161,168,175,182,189,196,203,210,217,224,231,238,245,252,259,266,273,280,287,294,301,308,315,322,329,336,343,350,357,364,371,378,385,392,399,406,413,420,427,434,441,448,455,462,469,476,483,490,497,504,511,518,525,532,539,546
        ],
        bronzeAge: [
          141,150,159,168,177,186,195,204,213,222,231,240,249,258,267,276,285,294,303,312,321,330,339,348,357,366,375,384,393,402,411,420,429,438,447,456,465,474,483,492,501,510,519,528,537,546,555,564,573,582,591,600,609,618,627,636,645,654,663,672
        ],
        minoanEra: [
          149,160,171,182,193,204,215,226,237,248,259,270,281,292,303,314,325,336,347,358,369,380,391,402,413,424,435,446,457,468,479,490,501,512,523,534,545,556,567,578,589,600,611,622,633,644,655,666,677,688,699,710,721,732,743,754,765,776,787,798
        ],
        classicGreece: [
          157,170,183,196,209,222,235,248,261,274,287,300,313,326,339,352,365,378,391,404,417,430,443,456,469,482,495,508,521,534,547,560,573,586,599,612,625,638,651,664,677,690,703,716,729,742,755,768,781,794,807,820,833,846,859,872,885,898,911,924
        ],
        earlyRome: [
          165,180,195,210,225,240,255,270,285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050
        ],
        romanEmpire: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        byzantineEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        ageOfTheFranks: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        feudalAge: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        iberianEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        kingdomOfSicily: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        highMiddleAges: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        earlyGothicEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ],
        lateGothicEra: [
          173,190,207,224,241,258,275,292,309,326,343,360,377,394,411,428,445,462,479,496,513,530,547,564,581,598,615,632,649,666,683,700,717,734,751,768,785,802,819,836,853,870,887,904,921,938,955,972,989,1006,1023,1040,1057,1074,1091,1108,1125,1142,1159,1176
        ]
      }).withOutput(ProductionOutputType.RANDOM_CURRENT_ERA_GOODS),
    ),
    new PassiveAura(
      PassiveAuraType.RANGED_CRITICAL_HIT_DAMAGE_MOD,
      EffectAmount.asPerLevel([6.7,8.3,10,11.7,13.3,15,16.7,18.3,20,21.7,23.3,25,26.7,28.3,30,31.7,33.3,35,36.7,38.3,40,41.7,43.3,45,46.7,48.3,50,51.7,53.3,55,56.7,58.3,60,61.7,63.3,65,66.7,68.3,70,71.7,73.3,75,76.7,78.3,80,81.7,83.3,85,86.7,88.3,90,91.7,93.3,95,96.7,98.3,100,101.7,103.3,105]),
      '%',
    )
  ]),
};

export default PalaceOfFineArts;
